import { axiosInstance } from './baseApi';

const profileApi = {
  getCreateProfileMetadata: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetInductionMetadata`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        siteId: siteId,
      },
    }),

  createProfile: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/InductNewProfile`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  deleteProfile: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/DeleteProfile`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  updateProfile: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfile`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  editProfilePersonalDetails: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfilePersonalDetails`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  editProfileNextOfKin: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfileNextOfKin`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  editProfileSafePass: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfileSafePass`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  editProfileEmployeeDetails: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfileEmployeeDetails`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  editProfilePicture: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfilePicture`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  retryRegistrationProfilePicture: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/RetryInductionProfilePicture`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  retryProfileInduction: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/RetryProfileInduction`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        profileId: data.profileId,
        siteId: data.siteId,
        accountId: data.accountId,
      },
    }),

  retrySiteProfileInductionBulk: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/RetrySiteProfileInductionBulk`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: data.accountId,
        siteId: data.siteId,
        statuses: data.statuses,
      },
    }),

  editProfileAccess: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/EditProfileAccess`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  /** Preview rule-based expiry when enabling auto-expiry on an existing Skillko profile (edit form). */
  getSkillkoAutomaticExpiryPreview: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoAutomaticExpiryPreview`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        profileId: data.profileId,
        siteId: data.siteId,
        accountId: data.accountId,
      },
    }),

  getProfileData: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfileData`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  updateProfileCertificates: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/UpdateProfileCertificates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  getProfilesFromSkillko: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfilesFromSkillko`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data
    }),

  getProfileFromSkillko: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/getProfileFromSkillko`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data
    }),

  getProfilesFromSitePass: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfilesFromSitePass`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data
    }),

  getProfileFromSitePass: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfileFromSitePass`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data
    }),

  getProfileTableView: (token, siteId, accountId, page = 1, pageSize = 100, searchTerm = null, sortBy = null, sortDirection = null) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfileTableView`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        siteId: siteId,
        page: page,
        pageSize: pageSize,
        searchTerm: searchTerm,
        sortBy: sortBy,
        sortDirection: sortDirection,
      },
    }),

  getUnifiedProfiles: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetUnifiedProfiles`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        siteId: siteId,
      },
    }),

  saveProfileDraft: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/SaveProfileDraft`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  activateProfileDraft: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ActivateProfileDraft`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        profileId: data.profileId,
        siteId: data.siteId,
        accountId: data.accountId
      },
    }),

  resetAntiPassback: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ResetAntiPassback`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        profileId: data.profileId,
        siteId: data.siteId,
        accountId: data.accountId
      },
    }),

  debugCertificates: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Profile/DebugCertificates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        tenantProfileId: data.profileId,
        accountId: data.accountId
      },
    }),

  getProfileActivities: (token, siteId, accountId, profileId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Profile/GetProfileActivities`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId,
        accountId,
        profileId,
      },
    }),

  getProfileEvents: (token, siteId, accountId, profileId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Profile/GetProfileEvents`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId,
        accountId,
        profileId,
      },
    }),

  getProfileAuditHistory: (token, siteId, accountId, profileId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetProfileAuditHistory`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId,
        accountId,
        profileId,
      },
    }),

  getDeletedProfiles: (token, siteId, accountId, page = 1, pageSize = 100, searchTerm = null, sortBy = null, sortDirection = null) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Profile/GetDeletedProfiles`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        siteId: siteId || null,
        page: page,
        pageSize: pageSize,
        searchTerm: searchTerm,
        sortBy: sortBy,
        sortDirection: sortDirection,
      },
    }),

  getDeletedProfileData: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetDeletedProfileData`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),

  importProfileDrafts: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ImportProfileDrafts`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: data,
    }),
};

export default profileApi;
